<script>
import Layout from "../../layouts/main";
import draggable from 'vuedraggable';

export default {
  components: {
    Layout,
    draggable
  },
  data() {
    return {
      categorias: [],
      isLoading: false,
      hayCambios: false
    };
  },
  methods: {
    async obtenerCategorias() {
      this.isLoading = true;
      try {
        const response = await fetch("https://humobarculinario.com/api/categorias_get_menu.php");
        if (!response.ok) throw new Error("Error al obtener las categorías");
        const data = await response.json();
        this.categorias = data;
      } catch (error) {
        console.error("Error fetching categories:", error);
        alert("Hubo un error al cargar las categorías. Intente de nuevo.");
      } finally {
        this.isLoading = false;
      }
    },
    async guardarOrden() {
      this.isLoading = true;

      const orden = this.categorias.map((cat, index) => ({
        id: cat.id,
        orden: index
      }));

      try {
        const response = await fetch("https://humobarculinario.com/api/categorias_guardar_orden.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(orden)
        });

        if (!response.ok) throw new Error("Error al guardar el orden");

        const data = await response.json();
        if (data.success) {
          alert("Orden guardado correctamente");
          this.hayCambios = false;
        } else {
          alert("Hubo un problema al guardar");
        }
      } catch (err) {
        console.error(err);
        alert("Error al guardar el orden");
      } finally {
        this.isLoading = false;
      }
    }
  },
  mounted() {
    this.obtenerCategorias();
  }
};
</script>


<template>
  <Layout>
    <div v-if="isLoading" class="loading-overlay">
    <div class="loading-spinner"></div>
    </div>

    <div class="menu-container">
      <div class="header">
        <h5>ORDENAR CATEGORIAS</h5>
        
        <button class="add-button" 
        @click="guardarOrden" 
        :disabled="!hayCambios || isLoading">
  <span v-if="isLoading">Guardando...</span>
  <span v-else>Guardar</span>
</button>
      </div>
      <table>
  <thead>
    <tr>
       <th style="width: 40px;"></th> <!-- Icono de mover -->
      <th style="width: 60px;">ID</th>
      <th style="width: 200px;">Nombre</th>
    </tr>
  </thead>
  <draggable
  v-model="categorias"
  tag="tbody"
  handle=".handle"
  @change="hayCambios = true"
>    <tr v-for="categoria in categorias" :key="categoria.id">
      <td class="handle" style="cursor: move;">☰</td>
      <td>{{ categoria.id }}</td>
      <td>{{ categoria.name }}</td>
    </tr>
  </draggable>
</table>

    </div>
  </Layout>
</template>


<style scoped>
.menu-container {
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.search-input {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.add-button {
  background-color: purple;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th, td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
.available {
  color: green;
  font-weight: bold;
}
.sold-out {
  color: red;
  font-weight: bold;
}
.icon-button {
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 5px;
  font-size: 16px;
}
.pagination {
  margin-top: 10px;
  text-align: center;
}
.pagination button {
  margin: 2px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
}
.pagination .active {
  background: purple;
  color: white;
}
/* Cargando overlay y spinner */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.loading-spinner {
  border: 4px solid #f3f3f3; /* Fondo gris claro */
  border-top: 4px solid purple; /* Color de la parte que gira */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  width: 300px;
}
.popup label {
  display: block;
  margin-top: 10px;
  font-weight: bold;
}
.popup input, .popup select {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.popup-buttons {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
}
.add-button, .delete-button {
  background-color: #4e583c;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
}
.add-button:hover, .delete-button:hover {
  background-color: black;
}
.cancel-button {
  background-color: black;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
  border: 1px solid black;
}
.cancel-button:hover {
  background-color: white;
  border: 1px solid black;
  color: black;
}
.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4e583c; /* <- cambia esto */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}
</style>
